import React from 'react';
import {Container} from "../../theme/elements";
import {
    asAnchor, VisuallyHidden,
} from 'govuk-react';
import {
    FooterContainer,
    InnerWrappper
} from './styles';

const AnchorTag = asAnchor('a');

function Footer() {
    return (
        <FooterContainer role="contentinfo">
            <Container>
                <InnerWrappper>
                    <VisuallyHidden>Support links</VisuallyHidden>
                    <ul>
                        <li><AnchorTag href="#">Help</AnchorTag></li>
                        <li><AnchorTag href="#">Privacy</AnchorTag></li>
                        <li><AnchorTag href="#">Cookies</AnchorTag></li>
                        <li><AnchorTag href="#">Contact</AnchorTag></li>
                        <li><AnchorTag href="#">Accessibility statement</AnchorTag></li>
                        <li><AnchorTag href="#">Terms and conditions</AnchorTag></li>
                        <li>
                            Built by the&nbsp;
                            <AnchorTag href="#">
                                Government of Ontario
                            </AnchorTag>
                        </li>
                    </ul>
                </InnerWrappper>
            </Container>
        </FooterContainer>
    );
}

export default Footer;